import { createMuiTheme } from '@material-ui/core/styles';
import { green, white, graphite } from "./material-colors";

const materialUiTheme = createMuiTheme({
    typography: {
        fontFamily: [
            'Muli',
            'sans-serif',
        ].join(','),
    },
    palette: {
        primary: {
            main: green,
        },
        secondary: {
            light: green,
            main: green,
            contrastText: green,
        },
    },
    overrides: {
        MuiTable:
        {
            root:
            {
                borderBottom: "1px solid rgba(224, 224, 224, 1);"
            }
        },
        MuiTableRow:
        {
            head:
            {
                borderBottom: "1px solid rgba(224, 224, 224, 1);"
            }
        },
        MuiTableCell:
        {
            body:
            {
                padding: "8px 0px",
                minHeight: "28px"
            },
            root:
            {
                padding: "unset",
                borderBottom: "unset"
            }
        },
        MuiPaper:
        {
            elevation1:
            {
                boxShadow: "none"
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 10,
                backgroundColor: white,
            },
        },
        MuiFormControl: {
            root: {
                borderRadius: 10
            }
        },
        MuiInputBase: {
            root: {
                fontSize: 'inherit'
            }
        },
        MuiListItemText: {
            primary: {
                color: graphite
            },
        },
        MuiTypography: {
            colorTextSecondary: {
                opacity: 0.6,
                color: graphite
            },
        },
        MuiListItemIcon: {
            root: {
                color: graphite
            },
        },
        MuiCheckbox: {
            root: {
                color: green
            },
        }
    },
});

export default materialUiTheme;
